import React from "react";
import { ZODIACS } from "../mock";

const Zodiac = () => {
  const items = [...ZODIACS, ...ZODIACS];
  return (
    <section className="zodiac">
      <div className="container">
        <div className="zodiac-head">
          <span className="section-label center">Know Your Rashi</span>
          <h2 className="section-title">
            What Your <em>Zodiac Sign</em><br/>Says About You
          </h2>
          <p className="section-desc" style={{ margin: "14px auto 0" }}>
            Contact Guruji to learn about your Rashi — personality, traits, life predictions and remedies.
          </p>
        </div>

        <div className="zodiac-scroll-wrap">
          <div className="zodiac-track">
            {items.map((z, i) => (
              <div className="zodiac-item" key={i}>
                <img src={z.img} alt={z.name} loading="lazy" />
                <p>{z.name}</p>
                <span>{z.sign}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Zodiac;
